import styled from "styled-components";
import { Card } from "antd";

export const Wrapper = styled(Card)`
  /* margin-top: 50px;
  margin-right: 10%;
  margin-left: 10%;
  margin-bottom: 20%;
  padding: 5% 8%;

  background: #ffffff;
  border: 1px solid #cecece;
  border-radius: 5px; */

  // height: 55vh;

  .form {
  }

  .rowContainer {
    display: flex;
    background: chocolate;
  }

  .rowAnexo {
    padding-left: 16%;
    padding-right: 40%;
    display: block;
    width: 100%;
    justify-content: space-between;
  }

  .conteinarButton {
    display: flex;
    float: right;
  }

  .inputDocumento {
    width: 100%;
  }

  .inputExpidor {
    width: 100%;
  }

  .button {
    margin-left: 20px;
    background: #00853b;
    border: none;
  }

  .areaBtnAnexo {
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: flex-start;
    font-size: 10px;
  }

  .areaBtnAnexo label {
    font-size: 0.7rem !important;
    color: #bb0000;
    width: 90%;
    line-height: 12px;
  }

  .btnAnexo {
    width: 212px;
  }

  .ant-descriptions-title {
    font-size: 1.6rem;
    color: #444444;
    font-weight: 500;
  }

  .duasCollumn {
    display: flex;
    justify-content: space-around;
    margin: -8px 0px;
  }

  .collumnContainer {
    display: block;
    background: chocolate;
  }

  .inputStyle {
    width: 100%;
  }

  .inputStyle input {
    border-radius: 50px;
  }

  .inputStyleNumero input {
    border-radius: 50px;
  }

  .loginContainer {
    display: flex;
    vertical-align: middle;
    cursor: pointer;
  }

  .login {
    margin-left: 10px;
    font-size: 1rem;
    transition: 0.5s;
  }

  .panelStyle p {
    color: #444;
    text-align: justify;
    font-size: 0.7rem;
  }

  /* class de divisão/atura/largura */

  .sizeBoxHeight {
    height: 20px;
  }

  .sizeBoxWidth {
    width: 20px;
  }

  @media (max-width: 600px) {
    .row {
      padding-left: 0;
      padding-right: 0;
      width: 100%;
    }

    .areaBtnAnexo {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .areaBtnAnexo label {
      width: 100%;
    }

    .btnAnexo {
      width: 250px;
    }

    .duasCollumn {
      display: block;
    }

    .rowContainer {
      display: block;
      padding-left: 0;
    }

    .rowAnexo {
      padding-left: 0;
      padding-right: 0;
      width: 50%;
    }

    .inputDocumento {
      width: 260px;
    }

    .conteinarButton {
      display: flex;
      justify-content: center;
      margin-left: auto;
      margin-right: auto;
      float: none;
    }

    .button {
      width: 210px;
      margin-left: 0px;
      margin-right: 0px;
    }
    .loginContainer {
      display: none;
    }
  }
`;
